import { lazy, Suspense, useEffect } from 'react';
import { isAccessPath } from './features/access/model';
import { isVideoPath } from './features/video/model';
import { isConsolePath } from './features/console/route';
import { Shell } from './features/shell/Shell';
import { useSession } from './state/sessionStore';

const SignInPage = lazy(() => import('./features/auth/SignInPage'));
const ConsolePage = lazy(() => import('./features/console/ConsolePage'));
const AccessPage = lazy(() => import('./features/access/AccessPage'));
const VideoPage = lazy(() => import('./features/video/VideoPage'));

export function App() {
  const status = useSession((s) => s.status);
  const error = useSession((s) => s.error);
  const load = useSession((s) => s.load);

  useEffect(() => {
    void load();
  }, [load]);

  switch (status) {
    case 'loading':
      return (
        <div className="splash" role="status">
          Loading…
        </div>
      );
    case 'signed-out':
      return (
        <Suspense fallback={<div className="splash" />}>
          <SignInPage />
        </Suspense>
      );
    case 'error':
      return (
        <div className="splash" role="alert">
          <p>Could not reach the server.</p>
          <p className="muted">{error}</p>
          <button type="button" className="btn" onClick={() => void load()}>
            Retry
          </button>
        </div>
      );
    case 'signed-in':
      if (isVideoPath(location.pathname))
        return (
          <Suspense fallback={<div className="splash" />}>
            <VideoPage />
          </Suspense>
        );
      if (isAccessPath(location.pathname))
        return (
          <Suspense fallback={<div className="splash" />}>
            <AccessPage />
          </Suspense>
        );
      return isConsolePath(location.pathname) ? (
        <Suspense fallback={<div className="splash" />}>
          <ConsolePage />
        </Suspense>
      ) : (
        <Shell />
      );
  }
}
